"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextInput = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
var _utils = require("../../utils");
var _Icon = require("../Icon");
var _excluded = ["value", "alwaysShowDescription", "contained", "description", "descriptionStyles", "descriptionRight", "disabled", "hideIconOnFocus", "icon", "iconPosition", "inputStyles", "label", "labelStyles", "multiline", "onBlur", "onFocus", "resizable", "rows", "htmlType", "wrapperStyles"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var TextInputIcon = function TextInputIcon(_ref) {
  var icon = _ref.icon,
    error = _ref.error,
    hideIconOnFocus = _ref.hideIconOnFocus;
  if (!icon) {
    return null;
  }
  if ((0, _lodash.isString)(icon)) {
    return /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      type: icon
      // Toggle visibility so that height of div isn't affected by Icon disappearing
      ,
      className: (0, _classnames.default)({
        'peer-focus:invisible': hideIconOnFocus
      }, error ? 'text-alertred-60' : 'text-green1-60'),
      "aria-hidden": true
    });
  }
  return /*#__PURE__*/_react.default.cloneElement(icon, {
    className: (0, _classnames.default)(icon.props.className, {
      'peer-focus:invisible': hideIconOnFocus
    })
  });
};
/**
 * Can be used with Antd form or on it's own as long as isValid is specified
 */
var TextInput = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var value = _ref2.value,
    _ref2$alwaysShowDescr = _ref2.alwaysShowDescription,
    alwaysShowDescription = _ref2$alwaysShowDescr === void 0 ? false : _ref2$alwaysShowDescr,
    contained = _ref2.contained,
    description = _ref2.description,
    descriptionStyles = _ref2.descriptionStyles,
    _ref2$descriptionRigh = _ref2.descriptionRight,
    descriptionRight = _ref2$descriptionRigh === void 0 ? false : _ref2$descriptionRigh,
    disabled = _ref2.disabled,
    _ref2$hideIconOnFocus = _ref2.hideIconOnFocus,
    hideIconOnFocus = _ref2$hideIconOnFocus === void 0 ? true : _ref2$hideIconOnFocus,
    icon = _ref2.icon,
    _ref2$iconPosition = _ref2.iconPosition,
    iconPosition = _ref2$iconPosition === void 0 ? 'right' : _ref2$iconPosition,
    inputStyles = _ref2.inputStyles,
    label = _ref2.label,
    labelStyles = _ref2.labelStyles,
    multiline = _ref2.multiline,
    _ref2$onBlur = _ref2.onBlur,
    onBlur = _ref2$onBlur === void 0 ? _lodash.noop : _ref2$onBlur,
    _ref2$onFocus = _ref2.onFocus,
    onFocus = _ref2$onFocus === void 0 ? _lodash.noop : _ref2$onFocus,
    resizable = _ref2.resizable,
    _ref2$rows = _ref2.rows,
    rows = _ref2$rows === void 0 ? 4 : _ref2$rows,
    _ref2$htmlType = _ref2.htmlType,
    htmlType = _ref2$htmlType === void 0 ? 'text' : _ref2$htmlType,
    wrapperStyles = _ref2.wrapperStyles,
    props = _objectWithoutProperties(_ref2, _excluded);
  var _useInputValidation = (0, _utils.useInputValidation)(props),
    error = _useInputValidation.error,
    validateOnBlur = _useInputValidation.validateOnBlur;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFocused = _useState2[0],
    setIsFocused = _useState2[1];
  var id = (0, _utils.useUniqueHtmlId)();
  var handleBlur = function handleBlur(e) {
    setIsFocused(false);
    validateOnBlur();
    onBlur(e);
  };
  var handleFocus = function handleFocus(e) {
    setIsFocused(true);
    onFocus(e);
  };
  var descriptionText = error || description || '';
  var inputProps = _objectSpread(_objectSpread({
    ref: ref,
    type: htmlType,
    id: id,
    'aria-describedby': "".concat(id, "-description"),
    className: (0, _classnames.default)('peer tw-label-regular w-full border-none outline-none p-0 bg-transparent disabled:cursor-not-allowed', {
      'resize-none': !resizable && multiline
    }, {
      'min-h-[20px]': resizable && multiline
    }),
    disabled: disabled,
    onFocus: handleFocus,
    onBlur: handleBlur,
    rows: rows
  }, props), {}, {
    // `props` also contains `value`
    // but we want to ensure `value` is an empty string
    value: value || ''
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('flex flex-col', {
      'text-input-invalid': error && !disabled
    }, {
      'pt-[23px]': label
    }, wrapperStyles)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('flex relative', contained || multiline ? 'text-input-contained' : 'text-input', {
      'text-input-disabled': disabled
    }, inputStyles)
  }, icon && iconPosition === 'left' && /*#__PURE__*/_react.default.createElement(TextInputIcon, {
    icon: icon,
    error: error,
    hideIconOnFocus: hideIconOnFocus
  }), multiline ? /*#__PURE__*/_react.default.createElement("textarea", inputProps) : /*#__PURE__*/_react.default.createElement("input", inputProps), icon && iconPosition === 'right' && /*#__PURE__*/_react.default.createElement(TextInputIcon, {
    icon: icon,
    error: error,
    hideIconOnFocus: hideIconOnFocus
  }), label && /*#__PURE__*/_react.default.createElement("label", {
    className: (0, _classnames.default)('text-input-label absolute pointer-events-none', value ? 'tw-caption-regular has-value' : 'tw-label-regular', value ? 'top-[-23px] left-0' : contained ? 'top-[10px] left-[10px] cursor-text' : 'top-0 cursor-text', 'peer-disabled:cursor-not-allowed peer-disabled:text-grey-40', 'peer-focus:tw-caption-regular', 'peer-focus:top-[-23px] peer-focus:left-0', {
      'left-[30px] pt-[3px]': icon && iconPosition === 'left' && !value
    }, labelStyles),
    htmlFor: id
  }, label)), descriptionText && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('text-input-description tw-caption-regular inline-block', 'pointer-events-none',
    // Used to animate description appearance
    descriptionText && isFocused || descriptionText && error || alwaysShowDescription ? 'mt-[6px] h-[17px]' : 'mt-0 h-0', isFocused || alwaysShowDescription ? 'opacity-100' : 'opacity-0', descriptionRight && 'text-right', descriptionStyles),
    id: "".concat(id, "-description")
  }, descriptionText));
});
exports.TextInput = TextInput;